import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.uploadBaseImage && _ctx.uploadBaseImage(...args))),
      accept: "image/*",
      class: "upload"
    }, null, 32),
    _createElementVNode("canvas", {
      ref: "canvasRef",
      class: "canvas-box",
      onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startDragging && _ctx.startDragging(...args))),
      onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragging && _ctx.dragging(...args))),
      onMouseup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopDragging && _ctx.stopDragging(...args))),
      onWheel: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleWheel && _ctx.handleWheel(...args)))
    }, null, 544)
  ], 64))
}